const ChildObject = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.666992C2.89543 0.666992 2 1.56242 2 2.66699V13.3337C2 14.4382 2.89543 15.3337 4 15.3337H12C13.1046 15.3337 14 14.4382 14 13.3337V2.66699C14 1.56242 13.1046 0.666992 12 0.666992H4ZM4 2.00033C3.63181 2.00033 3.33333 2.2988 3.33333 2.66699V13.3337C3.33333 13.7018 3.63181 14.0003 4 14.0003H5.33333V12.0003C5.33333 11.6321 5.63181 11.3337 6 11.3337H10C10.3682 11.3337 10.6667 11.6321 10.6667 12.0003V14.0003H12C12.3682 14.0003 12.6667 13.7018 12.6667 13.3337V2.66699C12.6667 2.2988 12.3682 2.00033 12 2.00033H4ZM9.33333 12.667H6.66667V14.0003H9.33333V12.667Z"
        fill="#A4A5B1"
      />
      <path
        d="M8 8.66699C7.63181 8.66699 7.33333 8.96547 7.33333 9.33366C7.33333 9.70185 7.63181 10.0003 8 10.0003H8.00667C8.37486 10.0003 8.67333 9.70185 8.67333 9.33366C8.67333 8.96547 8.37486 8.66699 8.00667 8.66699H8Z"
        fill="#A4A5B1"
      />
      <path
        d="M8 6.00033C7.63181 6.00033 7.33333 6.2988 7.33333 6.66699C7.33333 7.03518 7.63181 7.33366 8 7.33366H8.00667C8.37486 7.33366 8.67333 7.03518 8.67333 6.66699C8.67333 6.2988 8.37486 6.00033 8.00667 6.00033H8Z"
        fill="#A4A5B1"
      />
      <path
        d="M5.33333 8.66699C4.96514 8.66699 4.66667 8.96547 4.66667 9.33366C4.66667 9.70185 4.96514 10.0003 5.33333 10.0003H5.34C5.70819 10.0003 6.00667 9.70185 6.00667 9.33366C6.00667 8.96547 5.70819 8.66699 5.34 8.66699H5.33333Z"
        fill="#A4A5B1"
      />
      <path
        d="M5.33333 6.00033C4.96514 6.00033 4.66667 6.2988 4.66667 6.66699C4.66667 7.03518 4.96514 7.33366 5.33333 7.33366H5.34C5.70819 7.33366 6.00667 7.03518 6.00667 6.66699C6.00667 6.2988 5.70819 6.00033 5.34 6.00033H5.33333Z"
        fill="#A4A5B1"
      />
      <path
        d="M5.33333 3.33366C4.96514 3.33366 4.66667 3.63214 4.66667 4.00033C4.66667 4.36852 4.96514 4.66699 5.33333 4.66699H5.34C5.70819 4.66699 6.00667 4.36852 6.00667 4.00033C6.00667 3.63214 5.70819 3.33366 5.34 3.33366H5.33333Z"
        fill="#A4A5B1"
      />
      <path
        d="M8 3.33366C7.63181 3.33366 7.33333 3.63214 7.33333 4.00033C7.33333 4.36852 7.63181 4.66699 8 4.66699H8.00667C8.37486 4.66699 8.67333 4.36852 8.67333 4.00033C8.67333 3.63214 8.37486 3.33366 8.00667 3.33366H8Z"
        fill="#A4A5B1"
      />
      <path
        d="M10.6667 3.33366C10.2985 3.33366 10 3.63214 10 4.00033C10 4.36852 10.2985 4.66699 10.6667 4.66699H10.6733C11.0415 4.66699 11.34 4.36852 11.34 4.00033C11.34 3.63214 11.0415 3.33366 10.6733 3.33366H10.6667Z"
        fill="#A4A5B1"
      />
      <path
        d="M10.6667 6.00033C10.2985 6.00033 10 6.2988 10 6.66699C10 7.03518 10.2985 7.33366 10.6667 7.33366H10.6733C11.0415 7.33366 11.34 7.03518 11.34 6.66699C11.34 6.2988 11.0415 6.00033 10.6733 6.00033H10.6667Z"
        fill="#A4A5B1"
      />
      <path
        d="M10.6667 8.66699C10.2985 8.66699 10 8.96547 10 9.33366C10 9.70185 10.2985 10.0003 10.6667 10.0003H10.6733C11.0415 10.0003 11.34 9.70185 11.34 9.33366C11.34 8.96547 11.0415 8.66699 10.6733 8.66699H10.6667Z"
        fill="#A4A5B1"
      />
    </svg>
  );
};

export default ChildObject;
